// Brazilian phone utilities

// Returns digits-only string, stripping +55 country code if present.
// Accepts any input: "(11) 96181-4430", "+55 11 96181-4430", "11961814430"
export const normalizePhone = (input) => {
  if (!input) return '';
  let digits = String(input).replace(/\D/g, '');
  if ((digits.length === 12 || digits.length === 13) && digits.startsWith('55')) {
    digits = digits.slice(2);
  }
  return digits;
};

// Formats digits as Brazilian phone: "(11) 96181-4430" or "(11) 9618-4430"
export const formatPhoneBR = (input) => {
  const digits = normalizePhone(input).slice(0, 11);
  if (digits.length === 0) return '';
  if (digits.length <= 2) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  if (digits.length <= 10) return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7, 11)}`;
};

// Simple email regex
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isEmail = (value) => EMAIL_RE.test(String(value || '').trim());

// Detect whether input is email-like (contains @) — used during typing
export const looksLikeEmail = (value) => String(value || '').includes('@');
